import { format } from "date-fns";
import accounting from "accounting";
import { numFormat } from "@/utils/app.js"

const currency = (value, currencyName = "人民币") => {
  switch (currencyName) {
    case "人民币":
      return accounting.formatMoney(value, "¥ ");
    case "美元":
      return accounting.formatMoney(value, "$ ");
    case "欧元":
      return accounting.formatMoney(value, "€ ");
    case "港元":
      return accounting.formatMoney(value, "HK$ ");
    default:
      return accounting.formatMoney(value, "¥ ");
  }
};

const decimal = (value, precision = 2) => accounting.toFixed(value, precision);

const datetimeFormat = (value, pattern) =>
  !!value ? format(new Date(value), pattern) : "";

const date = value => (!!value ? format(new Date(value), "YYYY-MM-DD") : "");

const month = value => (!!value ? format(new Date(value), "YYYY-MM") : "");

const date_time = value =>
  !!value ? format(new Date(value), "YYYY年MM月DD日 HH:mm:ss") : "";
const month_CH = value =>
  !!value ? format(new Date(value), "YYYY年MM月") : "";

const verified = value => (value ? "通过" : "未通过");

const turnToPrice = value => numFormat(value);

export default {
  currency,
  decimal,
  datetimeFormat,
  date,
  month_CH,
  month,
  verified,
  turnToPrice,
  date_time
};
